import { Link, useLocation } from "react-router-dom";
import { Users, Calendar, Bell, BarChart3, LogOut, Menu, X, CalendarDays, Heart, UserCircle, FileText, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Sidebar({ user, logout, sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const isDisciple = user.role === 'disciple';
  const isSuperAdmin = user.role === 'super_admin';

  const superAdminNavigation = [
    { name: "Disciples", href: "/disciples", icon: Users },
    { name: "Attendance", href: "/attendance", icon: Calendar },
    { name: "Notifications", href: "/notifications", icon: Bell },
    { name: "Analytics", href: "/analytics", icon: BarChart3 },
    { name: "Reports", href: "/reports", icon: FileText },
    { name: "Events", href: "/events", icon: CalendarDays },
    { name: "Prayer Requests", href: "/prayer-requests", icon: Heart },
    { name: "User Management", href: "/user-management", icon: Shield },
    { name: "Profile", href: "/profile", icon: UserCircle }
  ];

  const leaderNavigation = [
    { name: "Disciples", href: "/disciples", icon: Users },
    { name: "Attendance", href: "/attendance", icon: Calendar },
    { name: "Notifications", href: "/notifications", icon: Bell },
    { name: "Analytics", href: "/analytics", icon: BarChart3 },
    { name: "Events", href: "/events", icon: CalendarDays },
    { name: "Prayer Requests", href: "/prayer-requests", icon: Heart },
    { name: "Profile", href: "/profile", icon: UserCircle }
  ];

  const discipleNavigation = [
    { name: "My Attendance", href: "/my-attendance", icon: Calendar },
    { name: "Notifications", href: "/notifications", icon: Bell },
    { name: "Events", href: "/events", icon: CalendarDays },
    { name: "Prayer Requests", href: "/prayer-requests", icon: Heart },
    { name: "Profile", href: "/profile", icon: UserCircle }
  ];

  const navigation = isDisciple ? discipleNavigation : (isSuperAdmin ? superAdminNavigation : leaderNavigation);

  return (
    <>
      <div className={`fixed top-0 left-0 h-full bg-white shadow-xl transition-all duration-300 z-50 ${sidebarOpen ? 'w-64' : 'w-20'}`}>
        <div className="flex flex-col h-full">
          <div className="p-6 border-b">
            <div className="flex items-center justify-between">
              <div className={`flex items-center gap-3 ${!sidebarOpen && 'justify-center'}`}>
                <img 
                  src="https://customer-assets.emergentagent.com/job_faith-pathway-1/artifacts/72w91eh6_image0-1536x1536.png" 
                  alt="AMI Logo" 
                  className="h-10 w-10 object-contain"
                />
                {sidebarOpen && (
                  <div>
                    <span className="font-bold text-lg gradient-text block" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                      Faith Pathway
                    </span>
                    <span className="text-xs text-gray-500 font-semibold">by AMI</span>
                  </div>
                )}
              </div>
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                data-testid="toggle-sidebar"
              >
                {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
              </button>
            </div>
          </div>

          <div className="flex-1 p-4">
            <nav className="space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.href;
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    data-testid={`nav-${item.name.toLowerCase()}`}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                      isActive
                        ? "bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-lg"
                        : "text-gray-700 hover:bg-gray-100"
                    } ${!sidebarOpen && 'justify-center'}`}
                  >
                    <Icon className="h-5 w-5" />
                    {sidebarOpen && <span className="font-medium">{item.name}</span>}
                  </Link>
                );
              })}
            </nav>
          </div>

          <div className="p-4 border-t">
            {sidebarOpen && (
              <div className="mb-4 p-3 bg-gradient-to-br from-purple-50 to-indigo-50 rounded-lg">
                <p className="font-semibold text-gray-800">{user.name}</p>
                <p className="text-sm text-gray-600">{user.email}</p>
                <span className="inline-block mt-2 px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full">
                  {user.role === 'super_admin' ? 'Super Admin' : 'Homecell Leader'}
                </span>
              </div>
            )}
            <Button
              data-testid="logout-button"
              onClick={logout}
              variant="outline"
              className={`w-full ${!sidebarOpen && 'px-2'}`}
            >
              <LogOut className="h-5 w-5" />
              {sidebarOpen && <span className="ml-2">Logout</span>}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}